import { gql } from "@apollo/client";
import {
  CustomerNoNestingFragment,
  LocationNoNestingFragment,
  PaginatedListMetaNoNestingFragment,
  PaymentNoNestingFragment,
  ProductKitItemNoNestingFragment,
  ProductKitNoNestingFragment,
  ProductNoNestingFragment,
  SaleAdjustmentNoNestingFragment,
  SaleFragment,
  SaleLineItemNoNestingFragment,
  SaleNoNestingFragment,
  StaffNoNestingFragment,
  TerminalNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const QUERY_SALE_LIST = gql`
  ${PaginatedListMetaNoNestingFragment}
  ${SaleNoNestingFragment}
  query sales($options: SaleListOptions) {
    sales(options: $options) {
      items {
        ...SaleNoNesting
        returnForId
        isReturn
        location {
          name
        }
        customer {
          id
          firstName
          lastName
          emailAddress
        }
      }
      meta {
        ...PaginatedListMetaNoNesting
      }
    }
  }
`;

export const QUERY_SALE_TRANSFER_STRING = gql`
  mutation saleTransferBase64String($saleId: ID!) {
    saleTransferBase64String(saleId: $saleId)
  }
`;

export const QUERY_GENERATE_GET_SALE_STRING = gql`
  mutation generateGetSaleString($saleId: ID!) {
    generateGetSaleString(saleId: $saleId)
  }
`;

export const QUERY_SALES_COUNT = gql`
  query salesCount($options: SaleListOptions) {
    salesCount(options: $options)
  }
`;

export const QUERY_SALE = gql`
  ${SaleFragment}
  ${SaleLineItemNoNestingFragment}
  ${PaymentNoNestingFragment}
  ${LocationNoNestingFragment}
  ${ProductNoNestingFragment}
  ${ProductKitNoNestingFragment}
  ${ProductKitItemNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  query sale($id: ID!) {
    sale(id: $id) {
      ...Sale
      returnForId
      isReturn
      location {
        name
      }
      customer {
        ...CustomerNoNesting
      }
      lineItems {
        ...SaleLineItemNoNesting
        product {
          ...ProductNoNesting
          image {
            path
          }
        }
        productKit {
          ...ProductKitNoNesting
          items {
            ...ProductKitItemNoNesting
            product {
              ...ProductNoNesting
              image {
                path
              }
            }
          }
        }
        adjustments {
          ...SaleAdjustmentNoNesting
        }
      }
      payments {
        ...PaymentNoNesting
        metadata
      }
    }
  }
`;

export const MUTATION_REFUND_SALE = gql`
  ${SaleFragment}
  ${SaleLineItemNoNestingFragment}
  ${PaymentNoNestingFragment}
  ${LocationNoNestingFragment}
  ${ProductNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  mutation initiateReturnSale($id: ID!) {
    initiateReturnSale(id: $id) {
      ...Sale
      isReturn
      returnForId
      location {
        name
      }
      customer {
        ...CustomerNoNesting
      }
      lineItems {
        ...SaleLineItemNoNesting
        product {
          ...ProductNoNesting
          image {
            path
          }
        }
        adjustments {
          ...SaleAdjustmentNoNesting
        }
      }
    }
  }
`;

export const MUTATION_VOID_SALE = gql`
  ${SaleFragment}
  ${SaleLineItemNoNestingFragment}
  ${PaymentNoNestingFragment}
  ${LocationNoNestingFragment}
  ${ProductNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  mutation voidSale($id: ID!) {
    voidSale(id: $id) {
      ...Sale
      isReturn
      returnForId
      location {
        name
      }
      customer {
        ...CustomerNoNesting
      }
      lineItems {
        ...SaleLineItemNoNesting
        product {
          ...ProductNoNesting
          image {
            path
          }
        }
        adjustments {
          ...SaleAdjustmentNoNesting
        }
      }
    }
  }
`;

export const MUTATION_TRANSFER_WEB_SALE = gql`
  ${SaleFragment}
  ${SaleLineItemNoNestingFragment}
  ${PaymentNoNestingFragment}
  ${LocationNoNestingFragment}
  ${ProductNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  mutation TranserWebSale($saleId: ID!) {
    transferWebSale(saleId: $saleId) {
      ...Sale
      isReturn
      returnForId
      location {
        name
      }
      customer {
        ...CustomerNoNesting
      }
      lineItems {
        ...SaleLineItemNoNesting
        product {
          ...ProductNoNesting
          image {
            path
          }
        }
        adjustments {
          ...SaleAdjustmentNoNesting
        }
      }
    }
  }
`;

export const MUTATION_CANCEL_SALE = gql`
  ${SaleFragment}
  ${SaleLineItemNoNestingFragment}
  ${PaymentNoNestingFragment}
  ${LocationNoNestingFragment}
  ${ProductNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${StaffNoNestingFragment}
  mutation cancelSale($id: ID!) {
    cancelSale(id: $id) {
      ...Sale
      isReturn
      returnForId
      location {
        name
      }
      customer {
        ...CustomerNoNesting
      }
      lineItems {
        ...SaleLineItemNoNesting
        product {
          ...ProductNoNesting
          image {
            path
          }
        }
        adjustments {
          ...SaleAdjustmentNoNesting
        }
      }
    }
  }
`;
